var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.995 7.006c-.39.39-.39 1.024 0 1.415l3.585 3.585-3.585 3.585c-.39.39-.39 1.024 0 1.415.39.39 1.024.39 1.414 0l3.585-3.585 3.585 3.585c.39.39 1.024.39 1.414 0 .39-.39.39-1.024 0-1.415l-3.585-3.585 3.585-3.585c.39-.39.39-1.024 0-1.414-.39-.39-1.024-.39-1.414 0l-3.585 3.585-3.585-3.585c-.39-.39-1.024-.39-1.414 0Z",
    fill: "#ec2222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.aa1df1e1ad9de20ef74fd05c37dad9e0.svg";
export { ForwardRef as ReactComponent };